import { render, staticRenderFns } from "./Popular.vue?vue&type=template&id=3c13f6d0"
import script from "./Popular.vue?vue&type=script&lang=ts"
export * from "./Popular.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports